import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema} from '/vercel/path0/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/markdoc/tags.js'
import * as nodes from '/vercel/path0/markdoc/nodes.js'
const functions = {};
const schema = {
tags: tags ? (tags.default || tags) : {},
nodes: nodes ? (nodes.default || nodes) : {},
functions: functions ? (functions.default || functions) : {},
...(config ? (config.default || config) : {}),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Documentation Ingestion\ndescription: Ingesting your documents in Mendable.\n---\n\n## Ingestion\n\n### Mendable Platform\n\nYou can ingest data entirely through our [platform](https://mendable.ai/signin) or you can contact us directly [here](https://fk4bvu0n5qp.typeform.com/to/vvGH3XMG). If you have filled out the form and haven't heard back, please email us at [garrett@sideguide.dev](mailto:garrett@sideguide.dev)\n\nor you can ingest data through our API.\n\n### Keeping your data updated (Auto Sync)\n\nMendable now offers reingestion for all users through the dashboard. To activate it, go to the Manage Indexes page. After you ingested from a data source that is supported (Website/Docs, GitHub, Notion, Zendesk + others), an auto sync option will appear in the Manage indexes page. You can then activate it and this will auto sync your data every 24 hours.\n\nIf you previously had a CRON job that was manually set up, it won't show up in the Auto Sync tab just yet.\n\n### Mendable API\n\nThe Mendable API is designed to ingest your data sources programatically. You can use the API to ingest your data sources and then use the Mendable platform to manage your data sources.\n\nTake a look at our [API documentation](/mendable-api/ingestion) to learn more about how to ingest your data sources.\n\n\n\n\n";
const filepath = "/ingestion.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
